export default __webpack_public_path__ + "static/media/logo.97684718.png";